import { SxProps } from "@mui/material";

export const sxFeatureCard: SxProps = {
  borderRadius: '10px',
  backgroundColor: '#FFF',
  boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08)',
  color: 'rgba(0, 0, 0, 0.08)',
  width: '100%',
  height: '120px',
  padding: '24px',
  fontFamily: 'Unimed-Sans',
  fontSize: '16px',
  fontWeight: '700',
  lineHeight: '24px',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  textTransform: 'none',
  '&:hover': {
    boxShadow: '0px 4px 50px 0px',
    backgroundColor: '#FFF',
    cursor: 'pointer'
  },

  'svg': {
    color: ' #00995D'
  }
}